import { render } from "./Modal.vue?vue&type=template&id=7c3f1a5c&scoped=true&bindings={\"label\":\"props\",\"darken\":\"props\",\"emitClose\":\"options\"}"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=7c3f1a5c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7c3f1a5c"

export default script